<template>
  <div id="top" class="mainWrapper">
    <!--nav-->
    <head-nav :gray="gray"></head-nav>
    <!--container-->
    <div class="innerWrapper">
      <h1>FAQ's</h1>
      <h2>
        Contact us at
        <a target="_blank" v-bind:href="'mailto:' + contactEmail">{{
          contactEmail
        }}</a>
        for other general enquiries not listed below.
      </h2>
      <div class="list">
        <div v-for="(faq, index) in faqs" :key="index" class="faq">
          <div class="qes" @click="shrink(faq.id)">
            <span class="newspan">{{ faq.title }}</span>
            <i :class="{ active: faq.spread }"></i>
          </div>
          <div
            :class="{ spread: faq.spread }"
            class="ans"
            v-html="faq.text"
          ></div>
        </div>
      </div>
    </div>
    <!--footer-->
    <foot-nav :showQus="false"></foot-nav>
  </div>
</template>

<script>
import headNav from "@/components/package/nav";
import footNav from "@/components/package/footer";
import { mapActions } from "vuex";

export default {
  data() {
    return {
      showTitle: false,
      gray: true,
      faqs: [],
      contactEmail: ""
    };
  },
  created() {
    var that = this;
    that.$box.loadings();
    that.getList({ callback: that.callback });
  },
  mounted() {
    document.getElementById("top").scrollIntoView();
  },
  methods: {
    ...mapActions("faq", ["getList"]),
    shrink(id) {
      var that = this;
      that.faqs.map(v => {
        if (v.id == id) {
          if (!v.spread) {
            v.spread = true;
            this.$forceUpdate();
          } else {
            v.spread = false;
            this.$forceUpdate();
          }
        }
      });
    },
    callback(res) {
      var that = this;
      that.$box.loadings(2);
      if (res.data.code == 0) {
        this.faqs = res.data.data.faqPojoList;
        this.faqs.forEach(v => {
          v.spread = false;
        });
        this.contactEmail = res.data.data.contactEmail;
      } else if (
        res.data.code == 90000 ||
        res.data.code == 90002 ||
        res.data.code == 90001
      ) {
        localStorage.clear();
        that.$router.push("/login");
      } else if (res.data.code == 8902 || res.data.code == 8901) {
        that.$box.alert("", res.data.message, "error");
        localStorage.clear();
        that.$router.push("/login");
      } else {
        that.$box.alert("", res.data.message, "error");
      }
    }
  },
  components: {
    headNav,
    footNav
  }
};
</script>

<style lang="scss" scoped>
.mainWrapper {
  width: 100%;
  position: relative;
}

.innerWrapper {
  width: 100%;
  margin: 0 auto;
  box-sizing: border-box;
  padding: 1.52rem 0.24rem 0.24rem 0.24rem;

  h1 {
    font-size: 0.58rem;
    color: #2a2929;
    margin-bottom: 0.32rem;
    font-family: ProximaNova-Semibold;
  }

  h2 {
    font-size: 0.3rem;
    word-break: break-word;
    line-height: 0.34rem;
    margin-bottom: 0.81rem;
    color: #3f3f46;

    span {
      color: #434043;
      font-family: ProximaNova-Semibold;
      text-decoration: none;
    }

    a {
      font-family: ProximaNova-Semibold;
      text-decoration: underline;
      color: #0391ff;
    }
  }

  .list {
    width: 100%;
    margin: 0 auto 1rem auto;

    .faq {
      width: 100%;
      box-sizing: border-box;
      border: 1px solid #dfdfdf;
      border-radius: 3px;
      margin-bottom: 0.32rem;

      .qes {
        display: flex;
        font-family: ProximaNova-Semibold;
        box-sizing: border-box;
        padding: 0.34rem 0.32rem 0.34rem 0.32rem;
        font-size: 0.3rem;
        line-height: 0.46rem;
        color: #3f3f46;
        position: relative;
        cursor: pointer;
        word-break: break-word;
        align-items: center;
      }

      .newspan {
        flex: 1;
      }

      i {
        width: 0.8rem;
        height: 0.2rem;
        margin-left: 0.54rem;
        background-size: 0.32rem 0.2rem;
        background-position: left center;
        background-repeat: no-repeat;
        background-image: url("../../assets/w.png");
      }

      .active {
        background-image: url("../../assets/u.png");
      }

      .ans {
        font-size: 0.3rem;
        line-height: 0.46rem;
        box-sizing: border-box;
        background: #f5f5f7;
        color: #3f3f46;
        height: 0;
        overflow: hidden;
        padding: 0 0.32rem;
        transition: all 0.5s;
        word-break: keep-all;
      }

      .spread {
        height: auto;
        padding: 0.32rem;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/faq/faq.vue